import { Injectable } from '@angular/core';
import { get1 } from 'src/utils/api';

export interface DocumentsReceivedParams {
  pageNumber?: number;
  pageSize?: number;
  status?: string;
  // Patient name, file name or document id — any one matching.
  search?: string;
  fromDate?: string;
  toDate?: string;
  currentStatus?: string;
  userIds?: string;
  documentLabel?: string;
  facilityIds?: string;
  state?: string;
  documentType?: string;
  costCenter?: string;
  senderName?: string;
  senderFax?: string;
  sourceSystem?: string;
  // CSV of referral_priority codes (crisis / asap / new).
  referralPriority?: string;
  sortColumn?: string;
  sortDirection?: string;
}

@Injectable({ providedIn: 'root' })
export class DocumentsReceivedService {
  private baseUrl = 'api/documentsreceived';

  // Takes an AbortSignal for the same reason ExceptionQueueService.getQueue does: a superseded
  // filter/sort/page request must not land after the newer one and overwrite the grid.
  getDocuments(params: DocumentsReceivedParams, signal?: AbortSignal) {
    return get1(this.baseUrl, { params, signal });
  }

  getSummary(signal?: AbortSignal) {
    return get1(`${this.baseUrl}/summary`, { signal });
  }
}
